/* @flow */
import * as React from 'react';

import InputText from 'components/InputText';

type Props = {
  input: { onChange: () => any, value: any },
  meta: { error: string, touched: boolean },
};

const FormInputText = (props: Props): React$Element<any> => {
  const { input, ...otherProps } = props;
  return <InputText {...input} {...otherProps} />;
};

export default FormInputText;
